export class TypedFlow {
  flowIndex = 0;
  selectOptions = { title: ' ' };
  typing = false;
  pageSelector = '';

  advanceToIndex(index) {
    this.flowIndex = index;
    let selector = this.pageSelector + ' .flowItem';
    let flowItems = document.querySelectorAll(selector),
      i;
    for (i = 0; i < flowItems.length; ++i) {
      flowItems[i].classList.remove('past');
      flowItems[i].classList.remove('active');
      if (i < index) {
        flowItems[i].classList.add('past');
      }
      if (i == index) {
        flowItems[i].classList.add('active');
      }
    }
  }

  private skipped = 0;

  start(index = 0) {
    this.advanceToIndex(index);
  }

  next(skip = 0) {
    this.skipped = skip;
    let index = this.flowIndex + 1 + skip;
    this.advanceToIndex(index);
  }

  back() {
    this.advanceToIndex(this.flowIndex - 1 - this.skipped);
    this.skipped = 0;
  }

  didFinishTypingForIndex(index) {
    // no-op
  }
}



// WEBPACK FOOTER //
// ./src/pages/flows/typed-flow/typed-flow.ts